<h2 mat-dialog-title>Coins an Sales User vergeben</h2>
<mat-dialog-content>
  <form>
    <mat-form-field appearance="outline" style="width: 100%; padding-top: 5px;">
      <mat-label>Anzahl Coins</mat-label>
      <input matInput type="number" [formControl]="amount" min="1" required>
      <mat-error *ngIf="amount.hasError('required')">Bitte geben Sie eine Anzahl ein</mat-error>
      <mat-error *ngIf="amount.hasError('min')">Mindestens 1 Coin</mat-error>
    </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Abbrechen</button>
  <button mat-flat-button color="primary" [disabled]="!amount.valid" (click)="onAdd()">Coins vergeben</button>
</mat-dialog-actions>
